import { FamilyCensus } from 'store/modules/subscriber/subscriber-imq/types';

type FamilyMemberType = FamilyCensus[string]['type'];

const FAMILY_MEMBER_TYPE_LABELS: Record<FamilyMemberType, string> = {
  PRIMARY: 'Primary',
  SPOUSE: 'Spouse',
  DEPENDENT: 'Dependent',
};

export const getFamilyMemberSelectLabel = (memberId: string, familyCensus: FamilyCensus): string => {
  const member = familyCensus[memberId];

  if (!member) {
    return '';
  }

  return `${member.name} (${FAMILY_MEMBER_TYPE_LABELS[member.type]})`;
};

export const buildMemberSelectOptions = (
  memberIds: string[],
  familyCensus: FamilyCensus,
): { value: string; label: string }[] => {
  return memberIds.map((memberId) => ({
    value: memberId,
    label: getFamilyMemberSelectLabel(memberId, familyCensus),
  }));
};
